import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Inject, input, InputSignal, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { WINDOW } from '@ng-web-apis/common';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { FeaturedCard } from 'src/types/graphql';
import { AvatarDirective } from '../../../common/avatar/avatar.directive';
import { EllipsisTooltipDirective } from '../../../common/ellipsis-tooltip/ellipsis-tooltip.directive';
import { OpenSnackBarService } from '../../../common/open-snack-bar/open-snack-bar.service';
import { navigateToExternalUrl } from '../../../common/utils/helpers';
import { GtagService } from '../../../common/gtag/gtag.service';

@Component({
  selector: 'sharry-featured-card',
  standalone: true,
  imports: [EllipsisTooltipDirective, NgStyle, AvatarDirective, MatButtonModule],
  templateUrl: './featured-card.component.html',
  styleUrls: ['./featured-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedCardComponent {
  data: InputSignal<FeaturedCard> = input.required<FeaturedCard>();

  constructor(
    @Inject(WINDOW) private window: Window,
    private openSnackBarService: OpenSnackBarService,
    private gtagService: GtagService,
    @Inject(I18NEXT_SERVICE) private translateService: ITranslationService,
  ) {}

  logoUrlExists: Signal<boolean> = computed((): boolean => !!this.data()?.logo?.url);

  goTo(event?: MouseEvent) {
    const { title, id, sharryKind, sharrySelection, externalUrl } = this.data();
    const itemCategory: string = sharryKind?.name;
    const trackingEvent = {
      event: 'select_item',
      ecommerce: {
        items: [
          {
            item_name: title,
            item_id: id,
            item_brand: 'Ruralis',
            item_category: itemCategory,
            item_variant: sharrySelection,
          },
        ],
      },
    };
    this.gtagService.pushEvent(trackingEvent, true);
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    navigateToExternalUrl(this.window, externalUrl, this.openSnackBarService, this.translateService);
  }
}
